import styled from 'styled-components'

export const Wrapper = styled.div<{ height: number }>`
  width: 100%;
  height: ${({ height }) => height}px;

  .recharts-cartesian-grid-horizontal line {
    stroke-dasharray: 4 4;
  }

  .recharts-cartesian-grid-vertical line {
    display: none;
  }

  .recharts-text {
    font-size: 1.2rem !important;
    fill: ${({ theme }) => theme.colors.gray80};
  }
`
